<template>
    <div class="container-center">


        <h3>洽谈通知</h3>

        <div class="msg-list-box">
            <div class="no-data-tip" v-if="msgList.length == 0"></div>
            <el-row v-else class="msg-list" v-for="li in msgList">
                <el-col :span="21">
                    <router-link
                        :to="{name:'InviteNegoDetail',params:{ fid: li.id, id:$route.params.id, name:$route.params.name }}">
                        {{ li.title }}
                    </router-link>
                    <el-tag v-if="li.readFlag!=1" type="warning" size="mini">未读</el-tag>
                </el-col>
                <el-col :span="3" class="text-right">{{ li.createDate }}</el-col>
            </el-row>
        </div><!-- .msg-list-box -->

        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
            >
            </el-pagination>
        </div>


    </div><!-- container-center -->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util'

export default {
    name: 'msg-list',
    data () {
        return {
            msgList: [],

            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    methods: {
        getMsgList () {
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/discuss/getDiscussInfoPageList',{
                pageNum: this.pager.pageNum,
                pageSize: this.pager.pageSize,
                supplierId: this.$root.stockId,
                projectId: this.$route.params.id
            }).then((res)=>{
                loading.close()
                if(res.data.result) {
                    this.$root.navs.push(
                        {name: this.$route.params.name, path:'/inviteMngInfo/'+ encodeURIComponent(this.$route.params.id)},
                        {name:'洽谈通知'}
                    )
                    this.msgList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                }
            })

        },
        handleCurrentChange (page) {
            util.toTop();
            this.pager.pageNum = page;
            this.getMsgList();
        }

    },
    created(){
        this.$root.navs = [
            {name:'招标管理',path:'/inviteMngList'}
        ]
        this.$root.headImage.src = banner
        this.$root.activeIndex = 'invite'
        this.$root.isPublic = false
    },
    mounted () {
        this.getMsgList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.msg-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.tabs-margin {margin:20px 0 40px 0;}

.msg-list-box {font-size:14px;margin:20px 0 80px 0;border:1px solid #e0e0e0;padding:40px 24px;border-radius:8px;}
.msg-list + .msg-list {width: 100%;border-top: 1px solid #E4E5E4;padding:8px 0;}
.msg-list {font-size: 14px;margin:0;line-height:28px;}
.msg-list a {color: #000;text-decoration: none;}
.msg-list a:hover {color: var(--cMain);}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/InviteNego.vue